import React from "react";
import styled from "@emotion/styled";
import TheThing from "images/characters/kuning.png";
import ImageFile from "images/about-com.jpg";
import CompfestLogo from "components/CompfestLogo";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 120px 32px 120px 32px;

  @media (max-width: 900px) {
    margin: 120px 24px 120px 24px;
  }

  @media (max-width: 640px) {
    margin: 120px 0 0 0;
  }
`;

const Name = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 150px;
  position: relative;

  svg {
    width: 810px;
  }

  #mobile {
    display: none;
  }

  @media (max-width: 900px) {
    margin-bottom: 96px;

    svg {
      width: 560px;
    }
    #mobile {
      display: block;
    }
    #desktop {
      display: none;
    }
  }

  @media (max-width: 640px) {
    svg {
      width: 80%;
    }
  }
`;

const Tagline = styled.p`
  position: absolute;
  font-size: 20px;
  width: 100%;
  margin: 0;
  top: 145px;
  left: 190px;

  @media (max-width: 900px) {
    text-align: center;
    margin-top: 20px;
    position: static;

    line-height: 26px;
  }

  @media (max-width: 640px) {
    text-align: center;
    margin-top: 20px;
    position: static;
    font-size: 15px;
    line-height: 1.5em;
  }
`;

const About = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const ImageContainer = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  position: relative;
  justify-content: flex-end;
  width: 100%;
  display: flex;
  margin: 0 1.5em 0 0;
  max-width: 580px;

  @media (max-width: 640px) {
    flex-basis: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    max-width: none;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 640px) {
    border-radius: 12px;
    height: auto;
  }
`;
const Thing = styled.img`
  position: absolute;
  bottom: -48px;
  right: -38px;
  height: 128px;

  @media (max-width: 640px) {
    height: 112px;
    right: auto;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 1em 0 0 1.5em;
  max-width: 580px;

  @media (max-width: 640px) {
    margin: 2em 1.5em 0 1.5em;
  }
`;

const BiggestEvent = styled.p`
  font-weight: bold;
  font-size: 1.5em;
  line-height: 1.25em;
  margin: 0;

  span {
    color: #ffc0e3;
  }

  @media (max-width: 640px) {
    font-size: 1.8em;
  }
`;

export default function AboutTop() {
  return (
    <Section>
      <Name>
        <CompfestLogo height="" />
        <Tagline id="desktop">
          Igniting Technological Awareness on Facing the Hyperconnected Era
        </Tagline>
        <Tagline id="mobile">
          Igniting Technological Awareness
          <br />
          on Facing the Hyperconnected Era
        </Tagline>
      </Name>
      <About>
        <ImageContainer>
          <Image src={ImageFile} />
          <Thing src={TheThing} />
        </ImageContainer>
        <Text>
          <BiggestEvent>
            <span>THE BIGGEST IT EVENT</span> HELD BY STUDENTS
          </BiggestEvent>
          <p>
            COMPFEST adalah acara IT tahunan terbesar yang diadakan oleh
            mahasiswa Fakultas Ilmu Komputer, Universitas Indonesia. Setiap
            tahunnya, COMPFEST bertujuan untuk memberi dampak bagi masyarakat
            melalui <b>Academy, Competition, Seminar,</b> dan <b>Main Event</b>.
            Tahun ini, COMPFEST akan membawa{" "}
            <b>
              <i>
                “Igniting Technological Awareness on Facing the Hyperconnected
                Era”
              </i>
            </b>{" "}
            sebagai tema besar.
          </p>
          <p>
            COMPFEST berharap dalam setiap acara, COMPFEST dapat mengembangkan
            dan meningkatkan kesadaran teknologi di Indonesia di masa{" "}
            <i>hyperconnected era</i>.
          </p>
        </Text>
      </About>
    </Section>
  );
}
